module.exports = __webpack_public_path__ + "static/media/refierev2.871bf75d.jpg";